import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment.development';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserInfo, UserRole } from '../models/user-info';
import { UsersInfoResponse } from '../models/users-info-response';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private baseUrl = environment.backURL;
  constructor(private readonly http: HttpClient) {}

  getUsersInfo(
    page: number,
    count: number,
    role?: UserRole,
  ): Observable<UsersInfoResponse> {
    let url = `${this.baseUrl}/users?page=${page}&count=${count}`;
    if (role) {
      url += `&role=${role}`;
    }
    console.log(url);
    return this.http.get<UsersInfoResponse>(url);
  }
  getLoggedUserInfo(): Observable<UserInfo> {
    const url = `${this.baseUrl}/users/info`;
    return this.http.get<UserInfo>(url);
  }

  createUser(
    email: string,
    password: string,
    role: UserRole,
  ): Observable<UserInfo> {
    const url = `${this.baseUrl}/users`;
    const body = { email, password, role };
    return this.http.post<UserInfo>(url, body);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  changePassword(newPassword: string, email?: string): Observable<any> {
    const emailUserToChange = email || localStorage.getItem('email');
    const url = `${this.baseUrl}/users/password`;
    const body = {
      password: newPassword,
      email_user_to_change: emailUserToChange,
    };
    return this.http.patch(url, body);
  }

  changeUserRole(userId: number, role: UserRole): Observable<UserInfo> {
    const url = `${this.baseUrl}/users/${userId}/role`;
    const body = { role: role };
    return this.http.patch<UserInfo>(url, body);
  }

  deleteUser(userId: number): Observable<void> {
    const url = `${this.baseUrl}/users/${userId}`;
    return this.http.delete<void>(url);
  }
}
